import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';

export default function CompromisoAmbiental() {
  const compromisos = [
    { icon:'🌱', titulo:'Ingredientes 100% naturales', desc:'Todas nuestras formulas usan ingredientes de origen natural, sin parabenos, sulfatos, silicones ni quimicos agresivos.' },
    { icon:'📦', titulo:'Envases biodegradables', desc:'Usamos empaques de vidrio, carton reciclado, latas reutilizables y bolsas de yute. Ningun plastico de un solo uso.' },
    { icon:'🔄', titulo:'Sistema de Refill', desc:'Trae tu envase vacio y recargalo. Reduce residuos, ahorra dinero y cuidas el planeta en cada recarga.' },
    { icon:'🐰', titulo:'Libre de crueldad animal', desc:'Nunca probamos en animales. Todos nuestros productos son cruelty-free y veganos en su mayoria.' },
    { icon:'🇨🇴', titulo:'Produccion local', desc:'Fabricamos en Pasto, Colombia. Apoyamos la economia local y reducimos la huella de carbono del transporte.' },
    { icon:'🌍', titulo:'Fundacion Ecociudad', desc:'Somos parte de la red de Fundacion Ecociudad, comprometidos con la sostenibilidad urbana en el sur de Colombia.' },
  ];
  return (
    <div>
      <Breadcrumb items={[{ label:'Wawita', href:'/' }, { label:'Compromiso ambiental' }]} />
      <div style={{ maxWidth:1000, margin:'0 auto', padding:'60px 24px' }}>
        <h1 style={{ fontFamily:'var(--font-display)', fontSize:'clamp(28px,5vw,42px)', color:'var(--forest)', marginBottom:8 }}>Compromiso ambiental</h1>
        <div style={{ width:60, height:4, background:'#9FBE6A', borderRadius:2, marginBottom:16 }} />
        <p style={{ fontSize:18, color:'var(--ink-light)', lineHeight:1.7, marginBottom:48, maxWidth:700 }}>
          En Wawita creemos que cuidarse y cuidar el planeta no son cosas opuestas. Cada decision que tomamos esta guiada por nuestro compromiso con la sostenibilidad.
        </p>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(260px,1fr))', gap:24, marginBottom:60 }}>
          {compromisos.map(c => (
            <div key={c.titulo} style={{ background:'#fff', borderRadius:16, padding:28, boxShadow:'var(--shadow-sm)', display:'flex', gap:20, alignItems:'flex-start' }}>
              <div style={{ fontSize:36, flexShrink:0 }}>{c.icon}</div>
              <div>
                <h3 style={{ fontFamily:'var(--font-display)', fontSize:18, color:'var(--forest)', marginBottom:8 }}>{c.titulo}</h3>
                <p style={{ fontSize:14, color:'var(--ink-light)', lineHeight:1.7 }}>{c.desc}</p>
              </div>
            </div>
          ))}
        </div>
        <div style={{ background:'linear-gradient(135deg, #1C3A1E, #2D5A30)', borderRadius:24, padding:48, textAlign:'center', color:'#fff' }}>
          <h2 style={{ fontFamily:'var(--font-display)', fontSize:30, color:'#9FBE6A', marginBottom:16 }}>Wawita te cuida y tu cuidas el planeta</h2>
          <p style={{ fontSize:16, color:'rgba(255,255,255,0.8)', lineHeight:1.7, maxWidth:600, margin:'0 auto 28px' }}>
            Cada producto que compras es un paso hacia un consumo mas consciente y responsable. Juntos construimos un mundo mas verde.
          </p>
          <a href="/" style={{ display:'inline-block', padding:'12px 32px', background:'#9FBE6A', color:'#1C3A1E', borderRadius:12, fontWeight:700, textDecoration:'none', fontSize:15 }}>Ver nuestros productos</a>
        </div>
      </div>
    </div>
  );
}
